<div>
    <h2>{{'configurador-consumos.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error': showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'configurador-consumos.filters.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                                     [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'global.almacen' | translate}} *</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                                     [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'configurador-consumos.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'configurador-consumos.filters.codigo' | translate}}</label>
                <input type="text" formControlName="codigoIntegracion">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'">
                <label>{{'configurador-consumos.filters.destino' | translate}}</label>
                <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('paisDestino')"
                                     [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-4'" class="radio-group move-left">
                <input type="radio" id="insercion" value="false" formControlName="dateType">
                <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
                <input type="radio" id="actualizacion" value="true" formControlName="dateType">
                <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
            </div>
            <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="id">{{'configurador-consumos.table.id' | translate}}</th>
                        <th class="date-long sortable sortable-biggest" (click)="toOrderBy('x=> x.des', 2)">
                            {{'configurador-consumos.table.desConfiguracion' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.des', 2)"></i>
                            </div>
                        </th>
                        <th class="date-long sortable" (click)="toOrderBy('x=> x.fechaUltUso', 3)">
                            {{'configurador-consumos.table.fechaUltimoUso' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.fechaUltUso', 3)"></i>
                            </div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Designacion.Cultivo.Campanya.PaisDenominacion.Denominacion.des', 4)">
                            {{'configurador-consumos.table.denominacion' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.Designacion.Cultivo.Campanya.PaisDenominacion.Denominacion.des', 4)"></i>
                            </div>
                        </th>
                        <th class="string sortable sortable-biggest" (click)="toOrderBy('x=> x.Designacion.Etiquetador.des', 5)">
                            {{'configurador-consumos.table.etiquetador' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.Designacion.Etiquetador.des', 5)"></i>
                            </div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Designacion.Cultivo.Finca.des', 6)">
                            {{'global.finca' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.Designacion.Cultivo.Finca.des', 6)"></i>
                            </div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Confeccion.des', 7)">
                            {{'configurador-consumos.table.confeccion' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.Confeccion.des', 7)"></i>
                            </div>
                        </th>
                        <th class="actions"><i class="fas fa-plus" (click)="create()" title="{{'configurador-consumos.tituloNew' | translate}}"></i></th>
                    </tr>
                </thead>
                <tbody *ngFor="let configuracion of configuraciones; trackBy: trackByConfiguracionId">
                    <tr>
                        <td class="id">{{configuracion.codigoIntegracion}}</td>
                        <td class="date-longest">{{configuracion.des}}</td>
                        <td class="date-long">{{configuracion.fechaUltUso | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="string">{{configuracion.desDenominacion}}</td>
                        <td class="string-longest">{{configuracion.desEtiquetador}}</td>
                        <td class="string">{{configuracion.desFinca}}</td>
                        <td class="string">{{configuracion.desConfeccion}}</td>
                        <td class="actions">
                            <i class="fas fa-pencil-alt" (click)="update(configuracion)" title="{{'titles.editar' | translate}}"></i>
                            <i class="far fa-trash-alt" (click)="askDelete(configuracion)" title="{{'titles.eliminar' | translate}}"></i>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!configuraciones || (configuraciones && configuraciones.length < 1)">
                    <tr>
                        <td colspan="8">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="configuraciones && configuraciones.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{configuracionId ? ('configurador-consumos.tituloEdit' | translate) : ('configurador-consumos.tituloNew' | translate)}}
            </h4>
        </header>
        <app-conf-consumos-new-edit [configuradorConsumoId]="configuracionId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-conf-consumos-new-edit>
    </div>
</div>
